// Коротка назва з повної юридичної: форми власності — абревіатурами (де б не стояли, будь-який регістр, латинська «I»
// замість «І»), назва філії без повтору головної організації:
//   «Товариство з обмеженою відповідальністю "Експансія", Харківська філія товариства з обмеженою відповідальністю "Експансія"»
//   → «ТОВ "Експансія", Харківська філія»
const I = "[ІIіi]"; // кирилична й латинська «і»
const w = (s) => s.replace(/і/g, I).replace(/ /g, "\\s+");
const FORMS = [
  ["товариство з обмеженою відповідальністю", "ТОВ"], ["товариства з обмеженою відповідальністю", "ТОВ"],
  ["товариство з додатковою відповідальністю", "ТДВ"], ["приватне акціонерне товариство", "ПрАТ"], ["публічне акціонерне товариство", "ПАТ"],
  ["акціонерне товариство", "АТ"], ["приватне підприємство", "ПП"], ["комунальне підприємство", "КП"], ["державне підприємство", "ДП"],
  ["фізична особа ?[-–—] ?підприємець", "ФОП"], ["відокремлений підрозділ", "ВП"], ["громадська організація", "ГО"],
  ["сільськогосподарське товариство з обмеженою відповідальністю", "СТОВ"], ["фермерське господарство", "ФГ"],
].map(([f, a]) => [new RegExp(`(^|[\\s,.(])${w(f).replace(/\? \?/g, "\\s*")}(?=[\\s"«“'(]|$)`, "giu"), a]);

export function shortName(full) {
  // М'які переноси й символи нульової ширини (трапляються в назвах з ЄРПН) — геть
  let s = String(full || "").replace(/[\u00AD\u200B-\u200D\u2060\uFEFF]/g, "").replace(/\s+/g, " ").trim();
  if (!s) return s;
  for (const [re, abbr] of FORMS.sort((a, b) => b[0].source.length - a[0].source.length)) s = s.replace(re, (m, pre) => `${pre}${abbr}`);
  s = s.replace(/(?<!\p{L})(ТОВ|ТДВ|ПрАТ|ПАТ|АТ|ПП|КП|ДП|ФОП|ВП|ГО|СТОВ|ФГ)(?=["«“])/gu, "$1 "); // «ТОВ"Норт» → «ТОВ "Норт»
  // Філія / відділення / підрозділ: прибираємо повтор головної організації після слова
  const m = s.match(/^(.*?(["«“][^"»”]+["»”]).*?,\s*[^,]*?(?:філія|філіал|відділення|підрозділ))\s+(?:ТОВ|ТДВ|ПрАТ|ПАТ|АТ|ПП|КП|ДП)\s*(["«“][^"»”]+["»”])\s*$/iu);
  if (m && m[2].slice(1, -1).toLowerCase() === m[3].slice(1, -1).toLowerCase()) s = m[1];
  return s;
}
